export enum RoutingStatus {
	SUCCESS,
	STOPPED_ROUTING_IS_ACTIVE,
	STOPPED_CHECKPOINT_ACTIVATED,
	STOPPED_CHECKPOINT_DESTINATION_ROUTE_MISSING,
	ERROR
}
